<ng-container *transloco="let t; read: 'dial-ongoing-call-dialog'">
  <ng-container *ngrxLet="callState$ as callState">
    <div *ngrxLet="listeningDuration$ | async as listeningDuration" class="dial-ongoing-call-dialog__content">
      <i
        class="dial-ongoing-call-dialog__content-icon pi"
        [ngClass]="{
          'pi-exclamation-triangle': callState === CallState.notInitiated || callState === CallState.failed,
          'pi-phone': callState === CallState.connecting || callState === CallState.connected,
          'dial-ongoing-call-dialog__content-icon--success': callState === CallState.connected,
          'pi-stop-circle': callState === CallState.terminated,
          'dial-ongoing-call-dialog__content-icon--error': callState === CallState.failed,
        }"
      ></i>

      <span>{{ t('body.' + callState) }}</span>

      <ng-container *ngIf="listeningDuration">
        <span *ngIf="callState === CallState.terminated">{{ t('listeningDurationPrefix') }}</span>
        {{ listeningDuration }}
      </ng-container>
    </div>

    <div class="dial-ongoing-call-dialog__actions">
      <ng-container *ngIf="callState === CallState.notInitiated; else callActions">
        <button class="p-button-text" pButton type="button" (click)="close()">{{ t('negateJoinButtonLabel') }}</button>
        <button pButton type="button" (click)="dial()">{{ t('confirmJoinButtonLabel') }}</button>
      </ng-container>

      <ng-template #callActions>
        <ng-container *ngrxLet="isCallOnMute$ as isCallOnMute">
          <p-button
            *ngIf="callState === CallState.connected"
            type="button"
            [label]="isCallOnMute ? t('unmuteButtonLabel') : t('muteButtonLabel')"
            [styleClass]="isCallOnMute ? 'p-button-primary' : 'p-button-secondary'"
            (click)="onToggleMute()"
          >
            <mat-icon class="pr-2">{{ isCallOnMute ? 'volume_off' : 'volume_up' }}</mat-icon>
          </p-button>
        </ng-container>
        <button class="p-button-text" pButton type="button" (click)="close()">{{ t('disconnectButtonLabel') }}</button>
      </ng-template>
    </div>
  </ng-container>
</ng-container>
